/**Packages */
import React from 'react';
import { Link } from 'react-router-dom';
/**Helpers */
import { manageAssistant } from '../../../helpers/assistant';
/* Components */
import { Header } from '../../shared/Header';
import { MainContentWrapper } from '../../shared/MainContentWrapper';
import { Footer } from '../../shared/Footer';

/* CSS */
import './style.css';

export const ErrorPage = () => {
  
  manageAssistant();
  const returnUrl = `/simulatore${localStorage.getItem('homePage') ? localStorage.getItem('homePage') : '/simulatore-commerciale.html'}`;
  
  return (
    <>
      <Header
        logo={
          { 
            image: './images/logo_compass.png',
            alt: 'Logo compass',
            redirect: returnUrl,
          }
        }
        isSimulator={true}
      />
      <MainContentWrapper isSimulator={true}>
        <section className="error-page">
          <div className="container main-content">
            <div className="row">
              <div className="d-block d-md-none col-12">
                <img
                  className="error-page__image error-page__image--mobile"
                  src="./images/alert.svg"
                  alt="Warning"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-10">
                <div className="row">
                  <div className="error-page__main-wrapper col-12">
                    <h1 className="error-page__title">Siamo spiacenti, ma qualcosa è andato storto.</h1>
                    <p className="error-page__text">Riprova più tardi.</p>
                    <div className="row">
                      <div className="col-xs-12 col-sm-6 u-flex-center u-flex-center--column calculate-btn-scp">
                        <Link className="error-page__button comman-btn-rpp red-btn-rpp full-width" to="/simulatore-commerciale.html">
                          Torna alla homepage
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-sm-none d-md-block col-md-2">
                <img
                  className="error-page__image error-page__image--desktop"
                  src="./images/alert.svg"
                  alt="Warning"
                />
              </div>
            </div>
          </div>
        </section>
      </MainContentWrapper>
      <Footer isSimulator={true} />
    </>
  );
}
